import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from '../../../components/Link';
import Confirm from 'react-confirm-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';

import CommonTable from '../../CommonTable/CommonTable';
import CustomPagination from '../../CustomPagination/CustomPagination';

import history from '../../../core/history';
import messages from '../../../locale/messages';
import { deletePopularLocation, updateLocationStatus } from '../../../actions/siteadmin/deletePopularLocation';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

import s from './PopularLocationManagement.css';
import bt from '../../../components/commonStyle.css';

class PopularLocationManagement extends React.Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      location: PropTypes.string,
      locationAddress: PropTypes.string,
      isEnable: PropTypes.string,
      images: PropTypes.string,
    })),
    deletePopularLocation: PropTypes.any,
    updateLocationStatus: PropTypes.any,
  };

  static defaultProps = {
    data: []
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      searchList: ''
    };
  }

  handleSearchChange = (searchList) => {
    const { refetch } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
    };
    this.setState({ searchList, currentPage: 1 });
    refetch(variables);
  }

  handleClick = () => {
    history.push('/siteadmin/popularlocation/add')
  }

  handleDeleteLocation = async (id, currentPage) => {
    const { deletePopularLocation, setStateVariable, data, refetch, demoRestriction } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage: currentPage > 1 && data?.results?.length == 1 ? currentPage - 1 : currentPage, searchList };
    const isRestrict = await demoRestriction({ restrictType: 'popularLocation', restrictValue: id });
    if (isRestrict) return;
    const deleteValue = await deletePopularLocation(id, currentPage);
    if (deleteValue?.status === 200) {
      this.setState({ currentPage: variables.currentPage });
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  handleLocationStatus = async (id, isEnable) => {
    const { updateLocationStatus, refetch, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({ restrictType: 'popularLocation', restrictValue: id });
    if (isRestrict) return;
    updateLocationStatus(id, isEnable);
    await refetch();
  }

  paginationData = (currentPage) => {
    const { refetch } = this.props;
    const { searchList } = this.state;
    let variables = { currentPage };
    this.setState({ currentPage, searchList });
    refetch(variables);
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.idLabel) },
      { data: formatMessage(messages.location) },
      { data: formatMessage(messages.locationAddress) },
      { data: formatMessage(messages.status) },
      { data: formatMessage(messages.setEnableDisable) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.delete) }
    ]
  }


  tbody = (props) => {
    const { data } = this.props;
    const { formatMessage } = props.intl;
    const { currentPage } = this.state;

    return data?.results?.map((value, key) => {
      return {
        id: key,
        data: [
          { data: value?.id },
          { data: value?.location },
          { data: value?.locationAddress },
          {
            data: value?.isEnable == 'true' ? formatMessage(messages.enabledLabel) : formatMessage(messages.disabledLabel)
          },
          {
            data: <a href="javascript:void(0)" onClick={() => this.handleLocationStatus(value?.id, value?.isEnable)} >
              {value?.isEnable == 'true' ? formatMessage(messages.disableLabel) : formatMessage(messages.enableLabel)}
            </a>
          },
          {
            data: <Link to={"/siteadmin/edit/popularlocation/" + value?.id}>
              <FormattedMessage {...messages.editLabel} />
            </Link>
          },
          {
            data: <div>
              <Confirm
                onConfirm={() => this.handleDeleteLocation(value?.id, currentPage)}
                body={formatMessage(messages.areYouSureDeleteWishList)}
                confirmText={formatMessage(messages.confirmDelete)}
                cancelText={formatMessage(messages.cancel)}
                title={formatMessage(messages.deletePopularLocationLabel)}
              >
                <a href="javascript:void(0)"><FormattedMessage {...messages.delete} /></a>
              </Confirm>
            </div>
          }
        ]
      }
    })
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { data } = this.props;
    const { currentPage } = this.state;


    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          isSearch
          isSearchAdd
          handleSearch={(e) => this.handleSearchChange(e?.target?.value)}
          title={formatMessage(messages.managePopularLocations)}
          addAction={this.handleClick}
          redirectionLabel={formatMessage(messages.addPopularLocation)}
        />
        {
          data?.count > 0 &&
          <div>
            <CustomPagination
              total={data?.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.locationsLabel)}
            />
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({});

const mapDispatch = {
  deletePopularLocation,
  updateLocationStatus,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
)(PopularLocationManagement);